import React, { FC } from 'react';
import styles from '../journey-explorer.module.scss';

interface DateFieldProps {
	label: string;
	value: string;
	min: string;
	max: string;
	fallback: string;
	onChange: (value: string) => void;
}

const DateField: FC<DateFieldProps> = ({ label, value, min, max, fallback, onChange }) => {
	const handleChange = (next: string) => {
		const iso = next ? (next < min ? min : next > max ? max : next) : fallback;
		if (iso !== value) {
			onChange(iso);
		}
	};

	return (
		<input
			type="date"
			className={styles.date_input}
			value={value}
			min={min}
			max={max}
			aria-label={label}
			onChange={(event) => handleChange(event.target.value)}
		/>
	);
};

export default DateField;
